var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.306 2.68 2.347 4.693c.32.654 1.174 1.28 1.894 1.4l4.253.707c2.72.453 3.36 2.427 1.4 4.373l-3.307 3.307c-.56.56-.867 1.64-.693 2.413l.947 4.094c.746 3.24-.974 4.493-3.84 2.8l-3.987-2.36c-.72-.427-1.907-.427-2.64 0l-3.987 2.36c-2.853 1.693-4.586.426-3.84-2.8l.947-4.094c.173-.773-.133-1.853-.693-2.413L1.8 13.853C-.147 11.907.48 9.933 3.2 9.48l4.253-.707c.707-.12 1.56-.746 1.88-1.4L11.68 2.68c1.28-2.547 3.36-2.547 4.627 0Z",
    fill: "#3BB7B6"
  })));
};

export { SvgStar as ReactComponent };
export default __webpack_public_path__ + "static/media/star.e8b10062.svg";